import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi, SideBarDef } from 'ag-grid-community';
import { Observable, of } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import { buildColumnDefs, mapData } from './grid.utilities';
import { SelectFloatingFilterComponent } from './select-floating-filter.component';
import { ToolPanelComponent } from './tool-panel/tool-panel.component';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {
  public frameworkComponents;
  private gridApi: GridApi;
  // private columnApi: ColumnApi;
  public columnDefs: ColDef[];
  public rowData: IPackageInfo[];
  public lastUpdate: string;
  public releaseId: string;
  public error: string;

  public sidebar: SideBarDef = {
    toolPanels: [
      {
        id: 'buttons',
        labelDefault: 'Controls',
        labelKey: 'toolbar',
        iconKey: 'columns',
        toolPanel: 'customToolPanel',
        toolPanelParams: {
          getPackageFiles: () => this.defaultConfig && this.defaultConfig.packageFiles,
          loadPackageFile: file => this.loadPackageFile(file)
        }
      }
    ],
    defaultToolPanel: 'buttons'
  };
  private defaultConfig: IConfig;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.frameworkComponents = {
      selectFloatingFilter: SelectFloatingFilterComponent,
      customToolPanel: ToolPanelComponent
    };

    this.loadConfig()
      .pipe(
        tap(config => (this.defaultConfig = config)),
        tap(({ releaseIdFile }) => this.loadReleaseID(releaseIdFile)),
        tap(({ packageFiles }) => this.loadPackageFile(packageFiles.find(p => !!p.default).url)),
        catchError(e => {
          console.error(e);
          this.error = `A problem occurred while loading the packages list. Please try again later.`;
          return of(e);
        })
      )
      .subscribe();
  }

  public onGridReady({ api /* , columnApi  */ }) {
    this.gridApi = api;
    // this.columnApi = columnApi;
  }

  public onFirstDataRendered() {
    this.gridApi.setSideBar(this.sidebar);
    this.gridApi.expandAll();
    // this.columnApi.autoSizeAllColumns();
    this.gridApi.sizeColumnsToFit();
  }

  private loadConfig(): Observable<IConfig> {
    return this.http.get<IConfig>('assets/config.json');
  }

  private loadPackageFile(url: string) {
    this.gridApi && this.gridApi.showLoadingOverlay();
    return this.http.get<IPackagesList>(url).subscribe(list => {
      this.lastUpdate = list.lastUpdate;
      const rowData = mapData(list.packagesList);
      this.gridApi.setRowData(rowData);
      this.gridApi.setColumnDefs([]);
      this.gridApi.setColumnDefs(buildColumnDefs(rowData, this.defaultConfig));
      this.onFirstDataRendered();
    });
  }

  private loadReleaseID(releaseIdFile: string) {
    this.http.get(releaseIdFile, { responseType: 'text' }).subscribe(releaseID => (this.releaseId = releaseID.substring(0, 11)));
  }

  onModelUpdated(d) {
    if(this.gridApi && this.gridApi.getDisplayedRowCount() == 0) {
      this.gridApi.showNoRowsOverlay();
    }
    if(this.gridApi && this.gridApi.getDisplayedRowCount() > 0) {
      this.gridApi.hideOverlay();
    }
  }
}
